requestAnimationFrame(() => {
	if (!customElements.get('product-form')) {
	customElements.define('product-form', class ProductForm extends HTMLElement {
		constructor() {
		super();
		this.form = this.querySelector('form');

		if (this.form) {
			this.form.querySelector('[name=id]').disabled = false;
			this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
			this.submitButton = this.querySelector('[type="submit"]');
		}
		
		this.cartNotification = document.querySelector('cart-notification');
		this.productInfo = this.closest('product-info');
		this.recipientFields = this.productInfo ? this.productInfo.querySelector('.js-personalized-fields') : null;
		this.recipientFieldsInputs = this.recipientFields ? this.recipientFields.querySelectorAll('input, textarea') : null;

		this.hideErrors = this.dataset.hideErrors === 'true';
		}

		connectedCallback() {
		this.initAnimatedButton();
		}

		disconnectedCallback() {
		if(this.animatedButtonInterval) clearInterval(this.animatedButtonInterval);
		}

		initAnimatedButton() {
		this.animatedButton = this.querySelector('.js-animated-product-button');

		if(!this.animatedButton) return;

		this.animatedButtonTimeout = 2000;
		this.animatedButtonInterval = setTimeout(() => this.animateButton(this.animatedButton), this.animatedButtonTimeout);
		}

		animateButton() {
		this.animatedButton.addEventListener('animationend', () => {
			this.animatedButton.classList.remove('button--css-animate');
			setTimeout(() => {
			this.animateButton(this.animatedButton);
			}, this.animatedButtonTimeout);
		}, { once: true });
		this.animatedButton.classList.add('button--css-animate');
		}

		onSubmitHandler(evt, disableCartNotification, callback) {
		evt.preventDefault();
		this.clearPersonalizedFieldsErrors();

		const personalizedFieldsErrors = this.validatePersonalizedFields();

		if(personalizedFieldsErrors.length) {
			this.handleErrorMessage(personalizedFieldsErrors.join(', '));
			return;
		}

		evt.target.focus();
		const submitButton = this.querySelector('[type="submit"]');
		if (submitButton && submitButton.classList.contains('loading')) return;

		this.handleErrorMessage();
		//   if (!disableCartNotification) {
			this.cartNotification.setActiveElement(document.activeElement);
		//   }
		if (submitButton) {
			submitButton.setAttribute('aria-disabled', true);
			submitButton.classList.add('loading');
			this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
		}
		
		const config = fetchConfig('javascript');
		config.headers['X-Requested-With'] = 'XMLHttpRequest';
		delete config.headers['Content-Type'];

		const formData = new FormData(this.form);

		//   if (!disableCartNotification) {
			formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
		//   }

		formData.append('sections_url', window.location.pathname);
		config.body = formData;
		
		fetch(`${routes.cart_add_url}`, config)
			.then((response) => response.json())
			.then((response) => {
				if (response.status) {
					publish(PUB_SUB_EVENTS.cartError, {
					source: 'product-form',
					productVariantId: formData.get('id'),
					errors: response.errors || response.description,
					message: response.message,
					});
					this.handleErrorMessage(response.description);
					this.error = true;
					alert(response.description);
					this.showCartDrawer(disableCartNotification);
					return;
				}
			
				if (!this.error)
					publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
				this.error = false;
				
				// this.cartNotification.renderContents(response, window.addToCartAction === 'notification');
			
				this.showCartDrawer(disableCartNotification);
			
				const quickAddModal = this.closest('quick-add-modal');

				if (quickAddModal) {
				document.body.addEventListener(
					'modalClosed',
					() => {
					setTimeout(() => {
						this.cartNotification.renderContents(response, window.addToCartAction === 'notification');
					});
					},
					{ once: true }
				);
				quickAddModal.hide(true);
				} else {
				this.cartNotification.renderContents(response, window.addToCartAction === 'notification');
				}
			})
			// .catch((e) => {
			//   console.error(e);
			//   if (callback) callback();
			// })
			.finally(() => {
			if (submitButton) {
				submitButton.classList.remove('loading');
				submitButton.removeAttribute('aria-disabled');
				this.querySelector('.loading-overlay__spinner').classList.add('hidden');
			}

			if (callback) callback();
			});

			return false;
		}

		showCartDrawer(disableCartNotification) {
			if (!disableCartNotification) {
				const cartIconBubble = document.getElementById('cart-icon-bubble');

				if(window.addToCartAction === 'cart_drawer' && cartIconBubble && window.enableCartDrawer) {
					cartIconBubble.dispatchEvent(new Event('triggetClick'));
				}	
			}
		}

		clearPersonalizedFieldsErrors() {
		if (!this.recipientFieldsInputs) return;

		this.recipientFieldsInputs.forEach(element => {
			element.classList.remove('error');
		});
		}

		validatePersonalizedFields() {
		const errors = [];
		
		if (this.recipientFieldsInputs) {
			this.recipientFieldsInputs.forEach(element => {
			if (element.hasAttribute('required') && element.value.trim() === '') {
				element.classList.add('error');
				if (errors.indexOf(window.cartStrings.emptyFieldError) == -1) {
				errors.push(window.cartStrings.emptyFieldError);
				}
			}
			
			if (element.getAttribute('maxlength') && element.value.length > parseInt(element.getAttribute('maxlength'))) {
				element.classList.add('error');
				if (errors.indexOf(window.cartStrings.maxLengthError) == -1) {
				errors.push(window.cartStrings.maxLengthError.replace(
					'{{ value }}',
					element.getAttribute('maxlength')));
				}
			}
			});
		}

		return errors;
		
		// Убираем класс .error при изменении содержимого полей ввода
		// form.addEventListener('input', function(event) {
		//   if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
		//     event.target.classList.remove('error');
		//   }
		// });
		}

		handleErrorMessage(errorMessage = false) {
		if (this.hideErrors) return;

		this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.js-product-form-error-message-wrapper');
		this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.js-product-form-error-message');

		this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

		if (errorMessage) {
			this.errorMessage.textContent = errorMessage;
		}
		}

		enableLoading() {
			this.classList.add('product-form--loading');

			if (this.submitButton) {
				// this.submitButton.setAttribute('aria-disabled', true);
				this.submitButton.classList.add('loading');
				this.submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');
			}
		}

		disableLoading() {
			this.classList.remove('product-form--loading');

			if (this.submitButton) {
				this.submitButton.classList.remove('loading');
				// this.submitButton.removeAttribute('aria-disabled');
				this.submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
			}
		}
	});

	customElements.define('product-forms', class ProductForms extends HTMLElement {
		constructor() {
		super();
		}

		connectedCallback() {
		this.buttons = this.querySelectorAll('.product-forms__button');
		this.products = this.querySelectorAll('.product-forms__products product-form');

		this.onButtonClickHandler = this.onButtonClick.bind(this);
		
		this.buttons.forEach(button => button.addEventListener('click', this.onButtonClickHandler));
		}

		disconnectedCallback() {
		this.buttons.forEach(button => button.removeEventListener('click', this.onButtonClickHandler));
		}

		addLoadingButton() {
		this.buttons.forEach(button => {
			button.setAttribute('aria-disabled', true);
			button.classList.add('loading');
		});
		}

		removeLoadingButton() {
		this.buttons.forEach(button => {
			button.classList.remove('loading');
			button.removeAttribute('aria-disabled');
		});
		}

		onButtonClick(event) {
		event.preventDefault();

		const addToCartRecursion = (index) => {
			if (!this.products[index]) return;

			if (index === 0) {
			this.addLoadingButton();
			}

			this.products[index].onSubmitHandler(event, index < this.products.length - 1, () => {
			// this.products[index].onSubmitHandler(event, false, () => {
			index < this.products.length - 1 ? addToCartRecursion(index + 1) : this.removeLoadingButton();
			});
		};

		addToCartRecursion(0);
		}
	});

	class VariantSelects extends HTMLElement {
			constructor() {
				super();
				this.product = this.closest('.product');
				this.addEventListener('change', this.onVariantChange);
			}
		
			onVariantChange(settings = {}) {
				this.updateOptions();
				this.updateMasterId();
				this.updateVariantProductAttribute();
				this.updatePickupAvailability();
				this.removeErrorMessage();
				this.removeActiveMedia();
				this.updateVariantStatuses();
				
				if (!this.currentVariant) {
					this.toggleAddButton(true, '', true);
					this.setUnavailable();
				} else {
					this.updateMedia();
					this.updateURL();
					this.updateVariantInput(settings);
					this.renderProductInfo();
					this.updateShareUrl();
				}
		
				this.updateThumbnailSlider();
			}
		
			updateOptions(options) {
				this.options = options || Array.from(this.querySelectorAll('select'), (select) => select.value);
			}
		
			changeOptions(options) {
				const selects = this.querySelectorAll('select');
		
				options.forEach((optionValue, index) => {
					const options = selects[index].querySelectorAll('option');
					
					options.forEach(option => {
						option.selected = option.value === optionValue;
					});
				});
			}
		
			updateMasterId() {
				this.currentVariant = this.getVariantData().find((variant) => {
					return !variant.options.map((option, index) => {
						return this.options[index] === option;
					}).includes(false);
				});
			}
		
			removeActiveMedia() {
				const mediaGalleries = this.product?.querySelector('media-gallery');
		
				if (!mediaGalleries) return;
		
				mediaGalleries.classList.remove('has-active');
			}
		
			updateMedia() {
				if (!this.currentVariant) return;
				if (!this.currentVariant.featured_media) return;
		
				const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
		
				mediaGalleries.forEach((mediaGallery) => {
					if(window.groupGallery) {
						mediaGallery.querySelectorAll('slider-component').forEach(slider => {
							slider.resetPages();
						});
						mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, !window.groupGallery);
					} else {
						mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, !window.groupGallery)
					}
				});
		
				const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
				if (!modalContent) return;
				const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
				modalContent.prepend(newMediaModal);
			}
		
			updateThumbnailSlider() {
				if (!window.groupGallery) return;
				if (!this.product) return;
		
				const thumbnailSlider = this.product.querySelector('.thumbnail-slider');
		
				if (!thumbnailSlider) return;
		
				thumbnailSlider.resetPages();
			}
		
			updateURL() {
				if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
				window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
			}
		
			updateShareUrl() {
				const shareButton = document.getElementById(`Share-${this.dataset.section}`);
				if (!shareButton) return;

				scriptController.executeWhenScriptLoaded(['share.js'], () => {
					shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
				});
			}
		
			updateVariantInput(settings) {
				const productForms = this.dataset.productType === 'card' ? [this.closest('form')] : document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
				
				productForms.forEach((productForm) => {
					const input = productForm.querySelector('input[name="id"]');
					input.value = this.currentVariant.id;
					input.dispatchEvent(new Event('change', { bubbles: true }));
				});
		
				if (this.dataset.productType !== 'card' && !settings.isFootbar) {
					const footbarProductForm = document.getElementById(`product-form-${this.dataset.section}-footbar`);
		
					if (footbarProductForm) {
						scriptController.executeWhenScriptLoaded(['animated-dropdown.js'], () => {
							const footbarInput = footbarProductForm.querySelector('select[name="id"]');
							footbarInput.value = this.currentVariant.id;
							footbarInput.dispatchEvent(new Event('change', { bubbles: true }));
						});
					}
				}
			}
		
			updateVariantStatuses() {
				const selectedOptionOneVariants = this.variantData.filter(
					(variant) => this.querySelector(':checked').value === variant.option1
				);
				const inputWrappers = [...this.querySelectorAll('.product-form__input')];
				inputWrappers.forEach((option, index) => {
					if (index === 0) return;
					const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
					const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
					const availableOptionInputsValue = selectedOptionOneVariants
						.filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
						.map((variantOption) => variantOption[`option${index + 1}`]);
					this.setInputAvailability(optionInputs, availableOptionInputsValue);
				});
			}
		
			setInputAvailability(elementList, availableValuesList) {
				elementList.forEach((element) => {
					const value = element.getAttribute('value');
					const availableElement = availableValuesList.includes(value);
		
					if (element.tagName === 'INPUT') {
						element.classList.toggle('disabled', !availableElement);
					} else if (element.tagName === 'OPTION') {
						element.innerText = availableElement
							? value
							: window.variantStrings.unavailable_with_option.replace('[value]', value);
					}
				});
			}
		
			updateVariantProductAttribute() {
				if(!this.product) return;
				if(this.currentVariant) {
					this.product.setAttribute('data-selected-variant-id', this.currentVariant.id);
				} else {
					this.product.removeAttribute('data-selected-variant-id');
				}
			}
		
			updatePickupAvailability() {
				const pickUpAvailability = document.querySelector('pickup-availability');
				if (!pickUpAvailability) return;
		
				if (this.currentVariant && this.currentVariant.available) {
					scriptController.executeWhenScriptLoaded(['pickup-availability.js'], () => {
						pickUpAvailability.fetchAvailability(this.currentVariant.id);
					});
				} else {
					pickUpAvailability.removeAttribute('available');
					pickUpAvailability.innerHTML = '';
				}
			}
		
			removeErrorMessage() {
				const section = this.closest('section');
				if (!section) return;
		
				const productForm = section.querySelector('product-form');
				if (productForm) productForm.handleErrorMessage();
			}
		
			renderProductInfo() {
				const productForm = this.closest('.product, .card-wrapper').querySelector('product-form');

				productForm.enableLoading();

				if (this.dataset.productType === 'card') {
					fetch(`${this.dataset.url}${this.dataset.url.indexOf('?') === -1 ? '?' : '&'}variant=${this.currentVariant.id}&view=product-cart`)
					.then((response) => response.text())
					.then((responseText) => {
						const product = this.closest('.card-wrapper');
						const html = new DOMParser().parseFromString(responseText, 'text/html')
						const mediaDestination = product.querySelector('.media');
						const mediaSource = html.querySelector('.media');
						const priceDestination = product.querySelector('.card-information__price');
						const priceSource = html.querySelector('.card-information__price');
						const badgeDestination = product.querySelector('.card__badge');
						const badgeSource = html.querySelector('.card__badge');

						const processContent = () => {
							if (priceSource && priceDestination) priceDestination.innerHTML = priceSource.innerHTML;
							if (badgeSource && badgeDestination) badgeDestination.innerHTML = badgeSource.innerHTML;
							if (badgeDestination) badgeDestination.classList.remove('visibility-hidden');
			
							const price = product.querySelector('.card-information__price');
			
							if (price) price.classList.remove('visibility-hidden');
							this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut, false, !this.currentVariant.available);	
							productForm.disableLoading();
						};
		
						if (mediaSource && mediaDestination) {
							const mediaWrapper = document.createElement('div');
		
							mediaWrapper.innerHTML = mediaSource.innerHTML;
			
							const mediaImage = mediaWrapper.querySelector('img');
			
							mediaImage.style = 'visibility: hidden;';
							mediaImage.addEventListener('load', () => {
								mediaImage.style = '';

								mediaDestination.querySelectorAll('img').forEach(element => {
									if(element !== mediaImage) element.remove();
								});

								processContent();
							});
							mediaDestination.insertBefore(mediaImage, mediaDestination.firstChild);
						} else {
							processContent();
						}
					});
				} else {
					const isQuickView = this.dataset.section.indexOf('quickadd-template') !== -1;
					const sectionIdParam = !isQuickView ? `&section_id=${this.dataset.section}` : '';
		
					fetch(`${this.dataset.url}?variant=${this.currentVariant.id}${sectionIdParam}`)
					.then((response) => response.text())
					.then((responseText) => {
						const priceId = `price-${this.dataset.section}`;
						const skuId = `Sku-${this.dataset.section}`;
						const stockId = `stock-${this.dataset.section}`;
						const html = new DOMParser().parseFromString(responseText, 'text/html');
						
						if(isQuickView) {
							const productElement = html.querySelector('section[id^="MainProduct-"]');
							const sectionId = productElement.dataset.section;
							
							productElement.innerHTML = productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
						}
						
						const priceDestination = document.getElementById(priceId);
						const priceSource = html.getElementById(priceId);
						const skuDestination = document.getElementById(skuId);
						const skuSource = html.getElementById(skuId);
						const stockDestination = document.getElementById(stockId);
						const stockSource = html.getElementById(stockId);
						const inventorySource = html.getElementById(
							`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
						);
						const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
		
						if (priceSource && priceDestination) priceDestination.innerHTML = priceSource.innerHTML;
						if (skuSource && skuDestination) skuDestination.innerHTML = skuSource.innerHTML;
						if (stockSource && stockDestination) stockDestination.innerHTML = stockSource.innerHTML;
						if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
		
						const price = document.getElementById(`price-${this.dataset.section}`);
						const sku = document.getElementById(`Sku-${this.dataset.section}`);
						const stock = document.getElementById(`stock-${this.dataset.section}`);
		
						if (price) price.classList.remove('visibility-hidden');
						if (sku) sku.classList.remove('visibility-hidden');
						if (stock) stock.classList.remove('visibility-hidden');
						if (stock) stock.classList[!stock.querySelector('.product__stock-content') ? 'add' : 'remove']('hidden');
						if (inventorySource && inventoryDestination)
							inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

						this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut, false, !this.currentVariant.available);
						productForm.disableLoading();
					});
				}
			}
		
			toggleAddButton(disable = true, text, modifyClass = true, isSoldOut) {
				const productForm = this.dataset.productType === 'card' ? this.closest('form') : document.getElementById(`product-form-${this.dataset.section}`);
				if (!productForm) return;
				const addButton = productForm.querySelector('[name="add"]');
				const addButtonText = productForm.querySelector('[name="add"] > span');
		
				if (!addButton) return;
		
				if (disable) {
					addButton.setAttribute('disabled', 'disabled');
					if (text) addButtonText.textContent = text;
				} else {
					addButton.removeAttribute('disabled');
					addButtonText.textContent = window.variantStrings.addToCart;
				}
		
				if(isSoldOut !== undefined) {
					if (isSoldOut) {
						addButton.classList.add('button--sold-out');
					} else {
						addButton.classList.remove('button--sold-out');
					}
				}
		
				if(this.dataset.productType !== 'card') {
					const productFootbarForm = document.getElementById(`product-form-${this.dataset.section}-footbar`);
					if (!productFootbarForm) return;
					const footbarAddButton = productFootbarForm.querySelector('[name="add"]');
					const footbarAddButtonText = productFootbarForm.querySelector('[name="add"] > span');
		
					if (disable) {
						footbarAddButton.setAttribute('disabled', 'disabled');
						if (text) footbarAddButtonText.textContent = text;
					} else {
						footbarAddButton.removeAttribute('disabled');
						footbarAddButtonText.textContent = window.variantStrings.addToCart;
					}
				}
		
				if (!modifyClass) return;
			}
		
			setUnavailable() {
				const button = this.dataset.productType === 'card' ? this.closest('form') : document.getElementById(`product-form-${this.dataset.section}`);
				const addButton = button.querySelector('[name="add"]');
				const addButtonText = button.querySelector('[name="add"] > span');
				let price;
		
				if(this.dataset.productType === 'card') {
					const productForm = this.closest('.product-form');

					if(productForm) {
						price = productForm.querySelector('.card-information__price');
					}
				} else {
					price = document.getElementById(`price-${this.dataset.section}`);
				}
		
				if (!addButton) return;
				addButtonText.textContent = window.variantStrings.unavailable;
				if (price) price.classList.add('visibility-hidden');
		
				if(this.dataset.productType === 'card') {
					const product = this.closest('product-form');
					const badge = product.querySelector('.card__badge');
					
					if (badge) badge.classList.add('visibility-hidden');
				}
			}
		
			getVariantData() {
				this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
				return this.variantData;
			}
		}
		
		customElements.define('variant-selects', VariantSelects);
		
		class VariantRadios extends VariantSelects {
			constructor() {
				super();
			}
		
			updateOptions() {
				const fieldsets = Array.from(this.querySelectorAll('fieldset'));
				this.options = fieldsets.map((fieldset) => {
					return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
				});
			}
		
			changeOptions(options) {
				const fieldsets = this.querySelectorAll('fieldset');
		
				options.forEach((optionValue, index) => {
					const inputs = fieldsets[index].querySelectorAll('input');
					
					inputs.forEach(input => {
						input.checked = input.value === optionValue;
					});
				});
			}
		}
		
		customElements.define('variant-radios', VariantRadios);

		scriptController.scripts.push('product-form.js');
	}
});